<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref } from "vue";

import cover1 from "@src/assets/images/login_cover.png";
import cover2 from "@src/assets/images/login_cover_2.png";

const covers = [cover1, cover2];
const index = ref(0);

const INTERVAL_MS = 8000;

let timer: number | undefined;

onMounted(() => {
    // inicio aleatorio entre cover 1 ou 2
    index.value = Math.floor(Math.random() * covers.length);

    timer = window.setInterval(() => {
        index.value = (index.value + 1) % covers.length;
    }, INTERVAL_MS);
});

onUnmounted(() => {
    if (timer) window.clearInterval(timer);
});

const currentCover = computed(() => covers[index.value]);
</script>

<template>
    <div class="h-full basis-1/2 md:block xs:hidden relative overflow-hidden">
        <Transition name="fade" mode="out-in">
            <div
                :key="currentCover"
                class="absolute inset-0 bg-no-repeat bg-center bg-cover"
                :style="{ backgroundImage: `url(${currentCover})` }"
            />
        </Transition>
    </div>
</template>


<style scoped>
.text-gradient {
    background: linear-gradient(to bottom right, #07070b, #bfc5e4);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

/* Fade suave */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 700ms ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
